import React, { use, useEffect, useState } from 'react';
import { AccordionComponent2Props } from '../../constants/interface.ts';
import { AnimatePresence, motion } from 'framer-motion';

const AccordionComponent2 = (props: AccordionComponent2Props) => {
    const { className = "", header, content } = props;
    const [isOpen, setIsOpen] = useState(false);
    const animationProps = {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -10, transition: { duration: 0.5, ease: "easeInOut" } },
        transition: { duration: 0.5, ease: "easeInOut" }
    };

    const toggleIsOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={className}>
            <div onClick={toggleIsOpen} className="w-fit cursor-pointer">
                {header(isOpen)}
            </div>
            <AnimatePresence>
                {
                    (isOpen) && (
                        <motion.div
                            {...animationProps}
                        >
                            {content(isOpen)}
                        </motion.div>
                    )
                }
            </AnimatePresence>
        </div>
    );
};

export default AccordionComponent2;